import React, { useEffect, useState } from "react";
import SearchableSelect from "./SearchableSelect";
import { ErrorType } from "../../types/common-type";
import handleClearError from "../methods/handleClearError";
import { useOrganizations } from "../customhook/hooks/useOrganizations";
import { useProjectsByOrgId } from "../customhook/hooks/projectHooks";
import { useLocationByProjectId } from "../customhook/hooks/locationHooks";
import { usePrograms } from "../customhook/hooks/programHooks";
import { useDepartmentByProgramId } from "../customhook/hooks/departmentHooks";
import { usePackageByDepartmentId } from "../customhook/hooks/packageHooks";

export interface FilterTypes {
  organization: string;
  project: string;
  location: string;
  program: string;
  department: string;
  package: string;
}

interface CommonFilterProps {
  filterData?: FilterTypes | any;
  colClass?: string | null;
  handleGetFilters?: (data: any) => void;
  hideDepartmentAndPackage?: boolean;
}

export const initialFilters = {
  organization: "",
  project: "",
  location: "",
  program: "",
  department: "",
  package: "",
};

const DEPENDENTS: Record<string, string[]> = {
  organization: ["project", "location", "program", "department", "package"],
  project: ["location", "program", "department", "package"],
  location: ["program", "department", "package"],
  program: ["department", "package"],
  department: ["package"],
  package: [],
};

const CommonFilterSelect: React.FC<CommonFilterProps> = ({
  colClass = null,
  filterData: initialFilterData,
  handleGetFilters,
  hideDepartmentAndPackage = false,
}) => {
  const [errors, setErrors] = useState<ErrorType>({});
  const [filterData, setFilterData] = useState<FilterTypes>({
    organization: "",
    project: "",
    location: "",
    program: "",
    department: "",
    package: "",
  });

  const { options: organizationOption, loading: loadingOrg } =
    useOrganizations();
  const { options: projectOptions, loading: loadingProject } =
    useProjectsByOrgId(filterData?.organization);
  const {
    options: locationOptions,
    loading: loadingLocation,
    selectedItem: selectedLocation,
  } = useLocationByProjectId(filterData?.project, filterData?.location);
  const { options: programOptions, loading: loadingProgram } = usePrograms(
    filterData?.project,
    selectedLocation?.location_name,
  );
  const { options: departmentOptions, loading: loadingDepartment } =
    useDepartmentByProgramId(filterData?.program);
  const { options: packageOptions, loading: loadingPackage } =
    usePackageByDepartmentId(filterData?.department);

  // handleFieldDataChange
  const handleFieldDataChange = (
    name: string,
    value: string,
    label: string,
  ) => {
    setFilterData((prev: any) => {
      const newValue = prev[name] == value ? "" : value;
      const updated = { ...prev, [name]: newValue };

      DEPENDENTS[name]?.forEach((dep) => {
        updated[dep] = "";
      });

      return updated;
    });
    handleClearError(setErrors, name);
  };

  useEffect(() => {
    handleGetFilters?.(filterData);
  }, [filterData]);

  return (
    <div>
      <div className="row gx-2 gy-0">
        <div className={`${colClass ?? "col-6 col-md-4"} mb-0 `}>
          <SearchableSelect
            // label="Client Account"
            label="Organization"
            name="organization"
            value={filterData?.organization}
            options={organizationOption}
            onChange={handleFieldDataChange}
            hasRowGrid={false}
            error={errors?.organization}
            loading={loadingOrg}
          />
        </div>
        <div
          className={`${colClass ?? "col-6 col-md-4"} mb-0 `}
          // onClick={() => handleFieldClick("project")}
        >
          <SearchableSelect
            // label="Program Name"
            label="Account"
            name="project"
            value={filterData?.project}
            options={projectOptions}
            onChange={handleFieldDataChange}
            hasRowGrid={false}
            disabled={!filterData?.organization}
            loading={loadingProject}
            // error={errors?.project}
          />
        </div>
        <div
          className={`${colClass ?? "col-6 col-md-4"} mb-0 `}
          // onClick={() => handleFieldClick("location")}
        >
          <SearchableSelect
            // label="Geography"
            label="Location"
            name="location"
            value={filterData?.location}
            options={locationOptions}
            onChange={handleFieldDataChange}
            hasRowGrid={false}
            disabled={!filterData?.project}
            loading={loadingLocation}
            // error={errors?.location}
          />
        </div>
        <div
          className={`${colClass ?? "col-6 col-md-4"} mb-0 `}
          // onClick={() => handleFieldClick("program")}
        >
          <SearchableSelect
            // label="Business Unit / Project"
            label="Program"
            name="program"
            value={filterData?.program}
            options={programOptions}
            onChange={handleFieldDataChange}
            hasRowGrid={false}
            disabled={!filterData?.location}
            loading={loadingProgram}
            // error={errors?.program}
          />
        </div>
        {/* <div
          className={`${colClass ?? "col-6 col-md-4"} mb-0 `}
          // onClick={() => handleFieldClick("department")}
        >
          <SearchableSelect
            // label="Department / Location"
            label="Department"
            name="department"
            value={filterData?.department}
            options={departmentOptions}
            onChange={handleFieldDataChange}
            hasRowGrid={false}
            disabled={!filterData?.program}
            loading={loadingDepartment}
            // error={errors?.department}
          />
        </div> */}
        {!hideDepartmentAndPackage && (
          <div className={`${colClass ?? "col-6 col-md-4"} mb-0`}>
            <SearchableSelect
              label="Department"
              name="department"
              value={filterData?.department}
              options={departmentOptions}
              onChange={handleFieldDataChange}
              hasRowGrid={false}
              disabled={!filterData?.program}
              loading={loadingDepartment}
            />
          </div>
        )}
        {/* <div
          className={`${colClass ?? "col-6 col-md-4"} mb-0 `}
          // onClick={() => handleFieldClick("package")}
        >
          <SearchableSelect
            // label="Verification Package"
            label=" Package"
            name="package"
            value={filterData?.package}
            options={packageOptions}
            onChange={handleFieldDataChange}
            hasRowGrid={false}
            disabled={!filterData?.department}
            loading={loadingPackage}
            // error={errors?.package}
          />
        </div> */}
        {!hideDepartmentAndPackage && (
          <div className={`${colClass ?? "col-6 col-md-4"} mb-0`}>
            <SearchableSelect
              label="Package"
              name="package"
              value={filterData?.package}
              options={packageOptions}
              onChange={handleFieldDataChange}
              hasRowGrid={false}
              disabled={!filterData?.department}
              loading={loadingPackage}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CommonFilterSelect;
